export enum CampaignSorting {
  LIST_CAMPAIGN_STATUS = 'LIST_CAMPAIGN_STATUS',
  LIST_CAMPAIGN_NAME = 'LIST_CAMPAIGN_NAME',
  LIST_CAMPAIGN_REWARD = 'LIST_CAMPAIGN_REWARD',
  LIST_CAMPAIGN_NOTIFY_USER = 'LIST_CAMPAIGN_NOTIFY_USER',
  LIST_CAMPAIGN_RECIPIENTS = 'LIST_CAMPAIGN_RECIPIENTS',
  LIST_CAMPAIGN_START_DATE = 'LIST_CAMPAIGN_START_DATE',
  LIST_CAMPAIGN_END_DATE = 'LIST_CAMPAIGN_END_DATE',
  LIST_CAMPAIGN_ACTIONS = 'LIST_CAMPAIGN_ACTIONS',
  LIST_CAMPAIGN_MINIMUM_SPEND = 'LIST_CAMPAIGN_MINIMUM_SPEND',
}
